import { render, staticRenderFns } from "./DocumentView.vue?vue&type=template&id=7cf2b2f2&scoped=true&"
import script from "./DocumentView.vue?vue&type=script&lang=ts&"
export * from "./DocumentView.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentView.vue?vue&type=style&index=0&id=7cf2b2f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf2b2f2",
  null
  
)

export default component.exports